import React from 'react'
import App from './App'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './resources/locales/it.json'
import fr from './resources/locales/fr.json'
import en from './resources/locales/en.json'
import es from './resources/locales/es.json'

import { useEffect } from 'react'

const translations = {
    fr: {
        translation: fr,
    },
    it: {
        translation: it,
    },
    gb: {
        translation: en,
    },
    es: {
        translation: es,
    },
}
const FALLBACK_LANGUAGE = 'it'

const Setup: React.FC = () => {
    const language = navigator.languages !== undefined ? navigator.languages[0] : navigator.language

    useEffect(() => {
        void i18n.use(initReactI18next).init({
            resources: translations,
            lng: language || FALLBACK_LANGUAGE,
            fallbackLng: FALLBACK_LANGUAGE,
            interpolation: {
                escapeValue: false,
            },
        })
    }, [])

    return <App />
}

export default Setup
